import { useState } from "react";
import { Layout, Menu } from "antd";
import {
  RiUserSettingsLine,
  RiShieldUserLine,
  RiSecurePaymentLine,
} from "react-icons/ri";
import { CiDiscount1 } from "react-icons/ci";
import { MdOutlineSettings } from "react-icons/md";
import { BsDatabaseGear } from "react-icons/bs";
import { LuFolderCog } from "react-icons/lu";
import { IoWalletOutline } from "react-icons/io5";
import { TbMenuOrder } from "react-icons/tb";
import { Link } from "react-router-dom";
import SubMenu from "antd/es/menu/SubMenu";
import orderImage from "../../images/order.svg";
import { BiSolidError } from "react-icons/bi";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";

import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { checkPermission } from "../../utils/helper/utils";

const { Sider } = Layout;
const LeftSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  return (
    <div className="relative">
      <Sider
        width={250}
        collapsible
        trigger
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        className="!bg-[#176B53]"
      >
        <div
          className={`logo flex justify-center h-[56px] my-4 transition-opacity duration-500`}
        >
          {collapsed ? (
            <img src="/qc-logo-white.svg" alt="logo" className="w-14" />
          ) : (
            <img src="/qc-logo-white.svg" alt="logo" className="" />
          )}
        </div>
        <Menu
          theme="dark"
          defaultSelectedKeys={"auto"}
          mode="inline"
          className="!bg-[#176B53]"
        >
          {checkPermission(
            ["Manage QC", "Manage Vendor", "Manage Canned Seller", "Manage Driver", "Manage Sub Admin"],
            permissionJson
          ) ? (
            <SubMenu
              key="2"
              icon={<RiUserSettingsLine className="!text-base !min-w-4" />}
              title="User Management"
            >
              {checkPermission(["Manage QC"], permissionJson) ? (
                <Menu.Item key="21">
                  <Link to="/manage-QC">Manage QC</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Manage Vendor"], permissionJson) ? (
                <Menu.Item key="22">
                  <Link to="/manage-vendor">Manage Vendor</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Manage Canned Seller"], permissionJson) ? (
                <Menu.Item key="26">
                  <Link to="/manage-seller">Manage Canned Seller</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Manage Driver"], permissionJson) ? (
                <Menu.Item key="23">
                  <Link to="/manage-driver">Manage Driver</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Manage Sub Admin"], permissionJson) ? (
                <Menu.Item key="25">
                  <Link to="/manage-sub-admin">Manage Sub Admin</Link>
                </Menu.Item>
              ) : null}
            </SubMenu>
          ) : null}
          {/* <Menu.Item
          key="3"
          icon={<RiTimeZoneLine className="!text-base !min-w-4" />}
        >
          <Link to="/timeslots-holidays">Timeslots & Holidays</Link>
        </Menu.Item> */}
          {checkPermission(["Roles"], permissionJson) ? (
            <Menu.Item
              key="4"
              icon={<RiShieldUserLine className="!text-base !min-w-4" />}
            >
              <Link to="/roles-permissions">Roles & Permissions</Link>
            </Menu.Item>
          ) : null}
          {checkPermission(
            [
              "Business Categories",
              "Zones",
              "Vehicle Type",
              "Packaging Type",
              "Drop zone",
              "Canned Vending Machine",
              "Item Sensitivity",
              "Subscriptions"
            ],
            permissionJson
          ) ? (
            <SubMenu
              key="5"
              icon={<BsDatabaseGear className="!text-base !min-w-4" />}
              title="Master data Management"
            >
              {checkPermission(["Business Categories"], permissionJson) ? (
                <Menu.Item key="51">
                  <Link to="/manage-business-categories">Business Categories</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Zones"], permissionJson) ? (
                <Menu.Item key="52">
                  <Link to="/manage-zones">Zones</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Vehicle Type"], permissionJson) ? (
                <Menu.Item key="56">
                  <Link to="/manage-vehicle-type">Vehicle Type</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Packaging Type"], permissionJson) ? (
                <Menu.Item key="55">
                  <Link to="/manage-packaging-type">Packaging Type</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Drop zone"], permissionJson) ? (
                <Menu.Item key="57">
                  <Link to="/manage-drop-zone">Drop Zone</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Canned Vending Machine"], permissionJson) ? (
                <Menu.Item key="58">
                  <Link to="/manage-canned-vending-machine">Canned Vending Machine</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Item Sensitivity"], permissionJson) ? (
                <Menu.Item key="53">
                  <Link to="/manage-item-sensitivity">Item Sensitivity</Link>
                </Menu.Item>
              ) : null}
              {checkPermission(["Subscriptions"], permissionJson) ? (
                 <Menu.Item key="54">
                  <Link to="/manage-subscription">Subscriptions</Link>
                </Menu.Item>
             
              ) : null}
            </SubMenu>
          ) : null}
          {checkPermission(["Manage CMS"], permissionJson) ? (
            <SubMenu
              key="6"
              icon={<LuFolderCog className="!text-base !min-w-4" />}
              title="Manage CMS"
            >
              <Menu.Item key="63">
                <Link to="/privacy-policy">Privacy Policy</Link>
              </Menu.Item>
              <Menu.Item key="62">
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </Menu.Item>
              <Menu.Item key="61">
                <Link to="/return-policy">Return Policy</Link>
              </Menu.Item>
              <Menu.Item key="64">
                <Link to="/vendor-enquires-list">Vendor Enquiry</Link>
              </Menu.Item>
            </SubMenu>
          ) : null}
          {checkPermission(["Manage Coupon"], permissionJson) ? (
            <Menu.Item
            key="17"
            icon={<CiDiscount1 className="!text-base !min-w-4" />}
          >
            <Link to="/manage-coupon">Manage Coupon</Link>
          </Menu.Item>
          ) : null}          
          {/* <Menu.Item
          key="7"
          icon={<MdOutlineNoteAlt className="!text-base !min-w-4" />}
        >
          <Link to="/enquiries-requests">Enquire now Form</Link>
        </Menu.Item> */}
          {checkPermission(["System Settings"], permissionJson) ? (
            <Menu.Item
              key="8"
              icon={<MdOutlineSettings className="!text-base !min-w-4" />}
            >
              <Link to="/system-settings">System Settings</Link>
            </Menu.Item>
          ) : null}
          {checkPermission(["Vendor Payouts"], permissionJson) ? (
            <Menu.Item
              key="9"
              icon={<IoWalletOutline className="!text-base !min-w-4" />}
            >
              <Link to="/vendor-payouts">Vendor Payouts</Link>
            </Menu.Item>
          ) : null}
          {checkPermission(["Driver Payouts"], permissionJson) ? (
            <Menu.Item
              key="10"
              icon={<RiSecurePaymentLine className="!text-base !min-w-4" />}
            >
              <Link to="/driver-payouts">Driver Payouts</Link>
            </Menu.Item>
          ) : null}
          {checkPermission(["Order Management"], permissionJson) ? (
            <Menu.Item
              key="11"
              icon={
                <img
                  src={orderImage}
                  alt="User"
                  className="w-[16px] h-[16px] rounded-none"
                  style={{ filter: "opacity(0.5)" }}
                />
              }
            >
              <Link to="/order-management">Order Management</Link>
            </Menu.Item>
          ) : null}
          {checkPermission(["Product Management"], permissionJson) ? (
            <Menu.Item
              key="15"
              icon={<TbMenuOrder className="!text-base !min-w-4" />}
            >
              <Link to="/product-management">Product Management</Link>
            </Menu.Item>
          ) : null}
          {/* <Menu.Item
          key="12"
          icon={<TbMenuOrder className="!text-base !min-w-4" />}
        >
          <Link to="/">Business Category</Link>
        </Menu.Item>
        <Menu.Item
          key="13"
          icon={<TbMenuOrder className="!text-base !min-w-4" />}
        >
          <Link to="/">Item Sensitivity</Link>
        </Menu.Item> */}
          {checkPermission(["Manage Modifiers"], permissionJson) ? (
            <Menu.Item
              key="14"
              icon={
                <img
                  src="images/modi.svg"
                  alt="User"
                  className="w-[16px] h-[16px] rounded-none"
                  style={{ filter: "opacity(0.5)" }}
                />
              }
            >
              <Link to="/manage-modifiers">Manage Modifiers</Link>
            </Menu.Item>
          ) : null}
          {(checkPermission(["Sales By Zone Report"], permissionJson) || checkPermission(["Sales By Item Report"], permissionJson) || checkPermission(["Sales By Customer Report"], permissionJson) || checkPermission(["Sales By Order Type Report"], permissionJson) || checkPermission(["Sales By Delivery Mode Report"], permissionJson) || checkPermission(["Sales By Time Slot Report"], permissionJson) || checkPermission(["Sales By Vendor Report"], permissionJson) || checkPermission(["Sales By Driver Report"], permissionJson) || checkPermission(["Coupon Report"], permissionJson) || checkPermission(["Sales Details Report"], permissionJson) || checkPermission(["Payment Report"], permissionJson) || checkPermission(["Late Order Report"], permissionJson) || checkPermission(["Refund Order Report"], permissionJson)) || checkPermission(["Cancelled Order Report"], permissionJson) ? (
            <Menu.Item
              key="16"
              icon={<BiSolidError className="!text-base !min-w-4" />}
            >
              <Link to="/report">Report</Link>
            </Menu.Item>
          ) : null}
        </Menu>
      </Sider>
      <div className="absolute top-[14px] right-[-42px] text-black text-xl z-[999]">
        {collapsed ? (
          <MenuUnfoldOutlined
            className="toggle-icon"
            onClick={toggleCollapsed}
          />
        ) : (
          <MenuFoldOutlined className="toggle-icon" onClick={toggleCollapsed} />
        )}
      </div>
    </div>
  );
};
export default LeftSidebar;
